import { IconProps } from "@velaro/velaro-component-lib";
import React from "react";
import { Link } from "react-router-dom";

export function Card({
  to,
  title,
  subtitle,
  icon,
  status,
  variant = "default",
  isFirstCard = false,
  onClick,
  appStatus
}: {
  to: string;
  title: string;
  subtitle: string;
  icon?: string | React.FC<IconProps>;
  status?: string;
  variant?: "default" | "integrations";
  isFirstCard?: boolean;
  onClick?: () => void;
  appStatus?: string;
}) {
  if (variant === "integrations") {
    return (
      <div className="w-full mb-4" onClick={onClick}>
        <div className="cursor-pointer">
          <div
            className={`h-48 md:h-60 p-6 bg-white rounded-lg shadow-md border border-slate-300 w-full hover:bg-gray-100 flex flex-col justify-center ${
              isFirstCard ? "border-dashed border-2" : ""
            }`}
          >
            <div
              className={`font-semibold group flex items-center gap-2 ${
                isFirstCard ? "justify-center" : "justify-between"
              }`}
            >
              <div
                className={`flex items-center gap-2 ${
                  isFirstCard ? "justify-center" : ""
                }`}
              >
                {icon && (
                  <div
                    className={`${
                      isFirstCard
                        ? ""
                        : "w-14 h-14 border-slate-300 relative mr-4 rounded border p-1 content-center"
                    }`}
                  >
                    {typeof icon === "string" ? (
                      <img src={icon} alt={title} />
                    ) : (
                      React.createElement(icon)
                    )}
                  </div>
                )}
                <h3 className="font-semibold">{title}</h3>
              </div>
              {!isFirstCard && appStatus !== "" && (
                <span
                  className={`rounded border flex items-center justify-center px-1 ${
                    appStatus === "Connected"
                      ? "bg-[#c8f2db] border-[#c8f2db]"
                      : "bg-slate-300 border-slate-300"
                  }`}
                >
                  {appStatus}
                </span>
              )}
            </div>
            <div className={`text-sm pt-2 ${isFirstCard ? "text-center" : ""}`}>
              {subtitle}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="w-80 h-36">
        <Link to={to}>
          <div className="border float-left rounded w-80 h-36 mr-4 mb-4 hover:shadow group">
            <div className="font-semibold mb-2 bg-cornflower-blue-400 group-hover:bg-cornflower-blue-500 text-slate-50 p-3 group">
              {title}
            </div>
            <div className="text-sm p-3">{subtitle}</div>
          </div>
        </Link>
      </div>
    );
  }
}
